
import qs from 'qs'
import Auth from './Auth'
import axios from 'axios'
import { REQUIRED } from '@/utils/rules'
import { convertUTCToLocal } from '@/utils/helpers'

export default {
  mixins: [Auth],
  data () {
    return {
      useDev: false,
      valid: true,
      endpoint: '',
      items: [],
      totalItems: 0,
      options: { itemsPerPage: 20 },
      loading: false,
      search: '',
      filter: {},
      filterOptions: {},
      filterActions: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      bulkEditedItem: {},
      bulkDefaultItem: {},
      dialog: false,
      bulkDialog: false,
      name: '',
      cancelToken: null,
      selectedLines: [],
      disableQueryOptions: false,
      footerProps: {
        itemsPerPageOptions: [10, 20, 50, 100, -1],
      },
      saving: false,
    }
  },
  computed: {
    params: function () {
      return this.disableQueryOptions ? {} : {
        limit: this.options.itemsPerPage,
        page: this.options.page,
        order_by: this.options.sortBy && this.options.sortBy[0] ? this.options.sortBy[0] : 'created_at',
        order_dir: this.options.sortDesc ? (this.options.sortDesc[0] === true || this.options.sortDesc[0] === undefined) ? 'desc' : 'asc' : 'desc',
        filters: this.filter,
      }
    },
    rules () {
      return [REQUIRED]
    },
      convertUTCToLocal: () => convertUTCToLocal,
  },
  watch: {
    params: {
      handler () {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  created () {
    const { q, limit, page, order_by, order_dir, ...filter } = this.$route.query
    const parsedFilter = qs.parse(filter)

    if (parsedFilter && parsedFilter.filters) {
      const filters = qs.parse(filter).filters
      const allowedFilters = this.$_.map(this.filterOptions, (fo, key) => key)
      this.$_.each(filters, (f, k) => {
        if (this.$_.includes(allowedFilters, k)) { return }

        delete filters[k]
      })
      this.filter = filters
    }
    if (limit) { this.options.itemsPerPage = limit }
    if (page) { this.options.page = parseInt(page) }
    if (order_by) { this.options.order_by = order_by }
    if (order_dir) { this.options.order_dir = order_dir }
    if (q) { this.search = q }
  },
  methods: {
    getDataFromApi () {
      if (!this.canList()) { return }

      if (this.cancelToken) { this.cancelToken.cancel('cancelled') }
      this.cancelToken = axios.CancelToken.source()

      this.loading = true

      this.$get(`/${this.endpoint}`, { ...this.params, q: this.search, cancelToken: this.cancelToken.token }, { mutateLocation: true, useDev: this.useDev })
        .then(response => {
          if (response.data.data) {
            this.items = response.data.data
            this.totalItems = response.data.total
            this.loading = false
          } else {
            this.items = response.data
            this.totalItems = response.data.length
            this.loading = false
          }
        })
        .catch(e => {
          if (e !== 'cancelled') this.loading = false
        })
    },
    setFilter: function (filter) {
      this.filter = filter
    },
    deleteItem (item) {
      if (!this.canDelete()) { return }

      const index = this.$_.findIndex(this.items, c => c.id === item.id)

      if (confirm(this.$t('confirm_delete', { type: this.$tc(this.name).toLowerCase() }))) {
        if (index >= 0) {
          this.$del(`/${this.endpoint}/${item.id}`, undefined, { useDev: this.useDev }).then(() => {
            this.items.splice(index, 1)
            this.$toast(`${this.$tc(this.name)} ${this.$t('has_been_deleted')}`)
          })
        }
      }
    },
    editItem (item) {
      if (!this.canUpdate()) { return }

      this.editedIndex = this.$_.findIndex(this.items, c => c.id === item.id)
      if (this.editedIndex !== -1) { this.editedItem = Object.assign({}, item) }
      this.dialog = true
    },
    save () {
      if (!this.editedItem.id && !this.canCreate()) { return }
      if (this.editedItem.id && !this.canUpdate()) { return }
      this.saving = true
      let url = this.endpoint

      if (this.editedItem.id) { url += `/${this.editedItem.id}` }

      this.$post(url, this.editedItem, { useDev: this.useDev }).then(() => {
        this.getDataFromApi()
        this.$toast(`${this.$tc(this.name)} ${this.$t('saved_correctly')}`)

        this.close()
      })
      .finally(() => {
        this.saving = false
      })
    },
    close () {
      this.dialog = false
      this.$refs.form && this.$refs.form.reset()
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
    saveBulk: function () {
      if (!this.editedItem.id && !this.canCreate()) { return }
      if (this.editedItem.id && !this.canUpdate()) { return }
      this.saving = true
      const useSelected = this.selectedLines && this.selectedLines.length

      const confirmText = useSelected ? 'confirm_bulk_update' : 'confirm_bulk_update_filter'

      const body = this.$_.pickBy(this.bulkEditedItem, this.$_.identity)

      let call = null
      if (useSelected) { call = () => this.$put(`/${this.endpoint}/update?ids=${this.$_.join(this.$_.map(this.selectedLines, 'id'))}`, body, { useDev: this.useDev }) } else call = () => this.$put(`/${this.endpoint}/update`, body, { useDev: this.useDev, query: { filters: { ...this.filter, q: this.search } } })

      if (confirm(this.$t(confirmText, { entity: this.$tc(this.name).toLowerCase(), count: this.selectedLines.length || this.totalItems }))) {
        call().then(() => {
          this.getDataFromApi()
          this.$toast(`${this.$tc(this.name)} ${this.$t('saved_correctly')}`)

          this.closeBulk()
        })
        .finally(() => {
          this.saving = false
        })
      }
    },
    closeBulk () {
      this.bulkEditedItem = this.bulkDefaultItem
      this.bulkDialog = false
    },
  },
}
